import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import Selectoption from "../../components/formikcomponent/SelectFieldWithLabel";
import Category from '../../components/Fields/Category';
import GridItem from "../../components/Grid/GridItem";
import GridContainer from "../../components/Grid/GridContainer";
import JsonPreview from '../PreviewTrivia';
import AuthenticatedPage from "../../ContextAndHOC/AuthenticatedPage";
import ErrorDialog from '../../components/ErrorDialog';
import SuccessDialog from '../../components/SuccessDialog';
import Resourceid  from '../../components/Fields/Resource';
import Persona from'../../components/Fields/Persona';
import DiseaseSegment from'../../components/Fields/DiseaseSegment';
import DrugCategory from '../../components/Fields/DrugCategory';
import TreatmentPhase from '../../components/Fields/TreatmentPhase';
import {string,mixed, array, object} from 'yup';
import { Typography, makeStyles, Button, Paper, Grid } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';
import Fieldtext from '../../components/Fields/FieldText';
import Constants from '../../components/Fields/DropDownList';
import Trigger from '../../components/Fields/Trigger';
import Objective from "../../components/Fields/Objective";
import CategoryTag from '../../components/Fields/CategoryTag';
import TopicTag from '../../components/Fields/TopicTag';
import {StatusCodes} from 'http-status-codes';
import AreaField from '../../components/Fields/VeevaContentId';
const TriviaForm = (props) => {
  const useStyles = makeStyles((theme) => ({
    heading: {
      maxWidth: "1100px",
      margin: "auto",
      fontSize: "40px",
      textAlign: "left",
      textDecoration: "none",
      color: "rgb(6, 48, 63)",
    },
    para: { padding: "15px", paddingLeft: "50px" },
    image: { marginBottom: "5px" },
    holder: { backgroundColor: "white", paddingTop: "30px" },
    main: { maxWidth: "1100px", margin: "auto" },
    paddingBottom: { paddingBottom: "30px" },
    inputItem: { width: "100%" },
    createUserSelect: {
      "& p": {
        maxWidth: "200px",
        textOverflow: "ellipsis",
        display: "inline-block",
        overflow: "hidden",
        whiteSpace: "nowrap !important",
      },
    },
    para1: { float: "right", paddingRight: "20px" },
    createUser:{ width:"230px", color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main,
    border: `1px solid${theme.palette.border.primaryBorder}`, borderRadius: "50px", margin: "8px 10px", padding: "7px 20px", textTransform: "uppercase",
    marginTop: "-2px", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main, color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}`, },
    [theme.breakpoints.down("sm")]: { width: "80%",marginLeft:"10px",}},
    successDialogOK: {color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid${theme.palette.border.primaryBorder}`,
    borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 15px", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main, color: theme.palette.text.hoverTextPrimaryColor,
    border: `1px solid ${theme.palette.border.hoverPrimaryBorder}` }},
    cancelBtn: { width: "230px", height: "40px", textTransform: "uppercase", backgroundColor: "rgba(255, 255, 255, 1)", color: "rgba(75, 123, 227, 1)", borderRadius: "25px",
    border: "1px solid rgba(0, 0, 0, 0.12)", marginLeft: 25, fontWeight: "500 !important",
  '&:hover': { color: '#1d5d90',  border: "1px solid " },[theme.breakpoints.down("sm")]: { width: "80%",marginLeft:0}},
    gridHeader: {
      paddingLeft: "5px",
      paddingBottom: "25px",
      paddingTop: "5px",
    },
    clr_title: { color: "rgba(74, 74, 74, 1)", fontSize: "15px" },
  }));

  const ERR_MESSAGE = "This field is required.";
  let validateWithSchema = object().shape({
    resourceid: string().required(ERR_MESSAGE),
    categorytag: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    topictag: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    category: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    trigger: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    treatmentphase: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    drugcategory: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    content: object().shape({
      question: string().max(250, "max 250 charater").required(ERR_MESSAGE),
      responsebody: string().max(StatusCodes.INTERNAL_SERVER_ERROR, "max 500 charater").required(ERR_MESSAGE),
      dayofsequence: string().required(ERR_MESSAGE).test('Digits only', 'This field accepts values 1-99', value => value <= 99 && value >= 1)
      .matches(/^\d+$/,'The field should have digits only'),
      responsetitle: string().max(StatusCodes.CONTINUE, "max 100 charater").required(ERR_MESSAGE),
      correctoptionid: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    }),
    diseasesegment: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    persona: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    objective: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
  });

  const classes = useStyles();
  const[errorTrivia,setErrorTrivia]=useState(false);
  const [load, setLoad] = useState(false);
  const [open, setOpen] =  useState(false);
  const [openpopup, setOpenpopup] = useState(false);
  const [sucessTrivia, setSucessTrivia] = useState(false);
  const [updatedMessage, setUpdatedMessage] = useState("");
  const[disabletrisubmit,setDisabletriSubmit]= useState(false);
  const [triviadata, setTriviadata] = useState({
    isdeleted:0,
    type:1,
    title: [''],
    resourceid: "",
    category:[],
    categorytag: [],
    treatmentphase: [],
    drugcategory:[],
    topictag: [],
    topicid: [],
    trigger: [],
    content: {
    options:[{id: 1, text:"FACT"}, {id: 2, text:"FICTION"}],
      question: "",
      responsebody: "",
      dayofsequence:'',
      responsetitle: "",
      correctoptionid:[],
    },
    diseasesegment: [],
    persona: [],
    objective:[],
     //targetactionid:''
  });
const handleCloseDialogTrivia = () => {
      setOpen(false);
      setSucessTrivia(false);
      props.history.push("/Home/Trivia");

  };
 const handleErrorUsertrivia = () => {
    setOpen(false);
    setErrorTrivia(false);
  };
const sendSucesstrivia = () => {
    setOpen(true);
    setSucessTrivia(true);
  };
  const sendErrortrivia = () => {
    setOpen(true);
    setErrorTrivia(true);
  };
 let InactivateTriviaButton = [<Button className={classes.successDialogOK} onClick={handleCloseDialogTrivia}>{"OK"}</Button>];
let InactivateTriviaButton1 = [<Button className={classes.successDialogOK} onClick={handleErrorUsertrivia}>{"OK"}</Button>];
  let  SuccessMessage = "Trivia Content has been created successfully.";
  let errorMessage1 = "Please Submit Again Content ID already exit";
 let selectOptions = [{value: 1,label: "Trivia_Daily_Sequence"},{value: 2,label: "Trivia_Conditional_Appointment"},{value: 3,label: "Trivia_Conditional_Symptom"}];
let option=[{value: 1,label: "Fact"},{value: 2,label: "Fiction"}];
let drugCategorytriviaValue=Constants.drugCategoryValue;
let treatmentPhasetriviaValue=Constants.treatmentPhaseValue;
let triggertriviaValue=Constants.triggeroption;
let categorytagtriviaValue=Constants.categoryValue;
let TopictagtriviaValue=Constants.TopictagValue;
let personaTriviaValue=Constants.personaValue;
let diseaseSegmenttriviaValue=Constants.diseaseSegmentValue;
let objectivetriviaValue=Constants.objectiveValue;

React.useEffect(()=>{
  setUpdatedMessage("Trivia Content has been Updated successfully.");
  if(props.location.clone === "clone"){
    setUpdatedMessage(SuccessMessage);
  }
  const Updatedata=(value,label,name)=>{
  let comingvalue = [];
        if(name===1){
         label.find((labelval) => {
          if (labelval.value === value||labelval.label===value) {
            comingvalue.push({value:labelval.value,label:labelval.label});
          }
        });
        } else {
          if (value) {
            for (let i = 0; i < value.length; i++) {
              label.find((valu) => {
                if (valu.label === value[i]) {
                  let topic = { value: valu.value, label: valu.label };
                  comingvalue.push(topic);
                }
              });
            }
          }
        }
return comingvalue;
};
 if(props.location.state){
triviadata.category=Updatedata(props.location.state.detail[0].category,selectOptions,1);
triviadata.category=triviadata.category[0];
if(props.location.clone !== "clone"){
  triviadata.resourceid=props.location.state.detail[0].resourceid;
}
triviadata.trigger=Updatedata(props.location.state.detail[0].trigger,triggertriviaValue);
triviadata.categorytag=Updatedata(props.location.state.detail[0].categorytag,categorytagtriviaValue);
triviadata.topictag=Updatedata(props.location.state.detail[0].topictag,TopictagtriviaValue);
triviadata.diseasesegment=Updatedata(props.location.state.detail[0].diseasesegment,diseaseSegmenttriviaValue);
triviadata.treatmentphase=Updatedata(props.location.state.detail[0].treatmentphase,treatmentPhasetriviaValue);
triviadata.drugcategory=Updatedata(props.location.state.detail[0].drugcategory,drugCategorytriviaValue);
triviadata.persona=Updatedata(props.location.state.detail[0].persona,personaTriviaValue);
triviadata.objective=Updatedata(props.location.state.detail[0].objective,objectivetriviaValue);
if(props.location.newversion_clone){
triviadata.veevacontentid=(props.location.state.detail[0].veevacontentid);}
if(props.location.state.detail[0].versionNumber!==props.location.state.detail[0].Version.newversion&&props.location.clone !== "clone"){
setDisabletriSubmit(true);
}
if(triviadata.content && props.location.state.detail[0].content){
triviadata.content.question=props.location.state.detail[0].content.question;
triviadata.content.responsebody=props.location.state.detail[0].content.responsebody;
triviadata.content.dayofsequence=props.location.state.detail[0].content.dayofsequence;
triviadata.content.responsetitle=props.location.state.detail[0].content.responsetitle;
triviadata.content.correctoptionid=Updatedata(props.location.state.detail[0].content.correctoptionid,option,1);
triviadata.content.correctoptionid=triviadata.content.correctoptionid[0];
setTriviadata(triviadata) ;
}
}
},[]);
 const handleClose = () => {
    setOpen(false);
    setOpenpopup(false);
  };
 const handlePreview = () => {
    setOpen(true);
    setOpenpopup(true);
  };
  const handleDisable = () => {
    if(props.location.clone === "clone"){
      return false;
    }
    if(props.location.state){
      return true;
    }
    return false;
  };
  return (
    <>
      <Typography className={classes.heading} component="h5">
        Trivia Form
      </Typography>
      <Formik
        enableReinitialize={true}
        validator={() => ({})}
        validationSchema={validateWithSchema}
        initialValues={triviadata}
        onSubmit={(values) => {
          setLoad(true);
          let sendingtriviavalue = ({ ...values, content: { ...values.content } });
          const GetInsertvalue = (value) => {
            let trigger = [];
            value.map((obj) => {
              trigger.push(String(obj.label));
            });
            return trigger;
          };
          sendingtriviavalue.trigger = GetInsertvalue(values.trigger);
          sendingtriviavalue.categorytag = GetInsertvalue(values.categorytag);
          sendingtriviavalue.diseasesegment = GetInsertvalue(values.diseasesegment);
          sendingtriviavalue.drugcategory = GetInsertvalue(values.drugcategory);
          sendingtriviavalue.treatmentphase = GetInsertvalue(values.treatmentphase);
          sendingtriviavalue.persona = GetInsertvalue(values.persona);
          sendingtriviavalue.objective = GetInsertvalue(values.objective);
          sendingtriviavalue.topictag = GetInsertvalue(values.topictag);
          sendingtriviavalue.category = values.category.value;
          sendingtriviavalue.content.correctoptionid = values.content.correctoptionid.value;
          async function sendTrivia() {
            let url;
            url = "/api/content/contentservice/saveTriviaResource";
            if(props.history.location.pathname.includes("revision") && props.location.clone !== "clone"){
              sendingtriviavalue.id = props.location.state.detail[0].id;
              url = "/api/content/contentservice/createRevisionForTriviaResource";
            }
            if(props.history.location.pathname.includes("version") && props.location.clone !== "clone"){
              sendingtriviavalue.id = props.location.state.detail[0].id;
              url = "/api/content/contentservice/createVersionForTriviaResource";
            }
            let response = await props.authenticatedApiCall("post", url, sendingtriviavalue);
            setLoad(false);
            if (response && response.status === StatusCodes.OK) {
              sendSucesstrivia();
            }
            if (response && response.status === StatusCodes.BAD_REQUEST) {
              sendErrortrivia();
            }
          }
          sendTrivia();
        }}
      >
        {({ values,validateForm,setFieldError}) =>
         <Form>
          <div className={classes.main}>
              <div className={classes.holder}>
               <GridContainer>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                   <Category categoryOptions= {selectOptions} />
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                 <Resourceid setFieldErrors={setFieldError} disabled={() => handleDisable()} />
                </GridItem>
                 <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                  <Trigger triggeroptions={triggertriviaValue}/>
                </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                  <CategoryTag categoryoption={categorytagtriviaValue}/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <TopicTag topictagoption={TopictagtriviaValue}/>
                  </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <DiseaseSegment diseaseSegmentoptions={diseaseSegmenttriviaValue}/>
                  </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <DrugCategory drugCategoryoptions={drugCategorytriviaValue}/></GridItem>
                      <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                  <Fieldtext name={"veevacontentid"} label="Veeva Content ID*" disabled={true}/>
                </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
              <Persona personaoptions={personaTriviaValue}/>
                </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                      <Objective objectiveoption={objectivetriviaValue}/>
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                 <TreatmentPhase treatmentPhaseoptions={treatmentPhasetriviaValue}/>
                </GridItem>
                      <GridItem md={12} lg={12} sm={12} xs={12}>
                    <Typography className={classes.gridHeader}>
                      <b className={classes.clr_title}>
                        Content
                      </b>
                    </Typography>
                      </GridItem>
                      <GridItem md={8} lg={8} sm={12} xs={12}  className={classes.paddingBottom}>
                     <Fieldtext name={"content[question]"} label="Trivia Question *" disabled={false}/>
                    </GridItem>
                  <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                   <AreaField name={"content[responsebody]"}  InputProps={{ multiline: true, rows: 6 }}  label="Message *"/>
                  </GridItem>
                      <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name='content[correctoptionid]'
                      options={option}
                      placeholder="Trivia Option *"
                      component={Selectoption}
                      label="Trivia Option *"
                      variant="filled"
                      isSearchable={false}
                      className={classes.createUserSelect + " " + "selectstyle"}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                   </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                   <Fieldtext name={"content[responsetitle]"} label="Response Title *" disabled={false}/>
                </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Fieldtext name={"content[dayofsequence]"} label="Day Sequence *" disabled={false}/>
                </GridItem>
            </GridContainer>
               </div></div>
           <Paper style={{ marginTop: "40px", width: "100%",boxShadow:"none",padding:"15px"}}>
                <Grid container style={{paddingBottom:'5px'}}>
                  <Grid item lg={9} md={9} sm={6} xs={6} style={{ width: '100%', textAlign: 'right' }}>
                    <Button onClick={handlePreview} className={classes.cancelBtn} >Preview</Button>
                      {openpopup ? (<JsonPreview open={open} handleClose={handleClose} list={values} />) : ( "" )}
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={6} style={{ width: '100%' }}>
                    <Button className={classes.createUser} onClick={() => validateForm().then(arg => { console.log(arg); })}
                    type="submit"disabled={disabletrisubmit}  > 
                    {load && <CircularProgress color="primary" style={{position: "absolute",right: "40%",top:"-140%"}} />}{"SUBMIT"} </Button>
                  </Grid>
                </Grid>
              </Paper>
        </Form>
         }
      </Formik>
        {sucessTrivia?props.location.state?<SuccessDialog successButton={InactivateTriviaButton} HeaderText={"Success"} BodyText={updatedMessage} dismiss={handleCloseDialogTrivia}/>
        :<SuccessDialog successButton={InactivateTriviaButton} HeaderText={"Success"} BodyText={SuccessMessage} dismiss={handleCloseDialogTrivia}/>:""}
        {errorTrivia?<ErrorDialog successButton={InactivateTriviaButton1}  HeaderText={errorMessage1}  dismiss={handleErrorUsertrivia}/>:""}
    </>
  );
};

export default (AuthenticatedPage()(TriviaForm));
